import {createFileRoute} from '@tanstack/react-router'

import Ga4Screen from '@protected/ga4'

export const Route = createFileRoute('/_protected/ga4')({component: Ga4Screen})
